import { FunctionComponent, ReactNode } from 'react';

// Utilities
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Components
import InputSearch, { InputSearchProps } from '@Components/Layout/Search/Components/InputSearch';

// Styles
import styles from './SearchUI.module.scss';

export interface SearchUIProps {
    title?: string;
    className?: string;
    titleClassName?: string;
    subTitleClassName?: string;
    subTitle?: string | ReactNode;
    inputSearchClassName?: string;
    onSearch?: (keyword: string) => void;
}

const SearchUI: FunctionComponent<InputSearchProps & SearchUIProps> = ({className, title, subTitle, titleClassName, subTitleClassName, inputSearchClassName, ...props}) => {
    const { deviceType } = useViewDetected();

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        className,
    ]);

    return (
        <div className={wrapperClassName}>
            {title && <div className={classnames([styles.title, titleClassName])}>{title}</div>}
            {subTitle && <div className={classnames([styles.sub_title, subTitleClassName])}>{subTitle}</div>}
            <InputSearch
                {...props}
                className={classnames(inputSearchClassName)}
            />
        </div>
    );
};

SearchUI.defaultProps = {
    title: '',
    subTitle: '',
    className: '',
    titleClassName: '',
    subTitleClassName: '',
    inputSearchClassName: '',
};

export default SearchUI;
